import React from 'react'

interface KanbanContainerProps {
  children: React.ReactNode
}

export const KanbanContainer: React.FC<KanbanContainerProps> = ({
  children,
}) => {
  return <div className="container-kanban">{children}</div>
}
